import { Form, Input } from 'antd';
import React from 'react';
import { BaseInputFieldProps } from './BaseInputFieldProps';

const PasswordField: React.FunctionComponent<BaseInputFieldProps> = ({
  name,
  prefix,
  placeholder,
  rules,
  autocomplete = 'off',
  label,
  className,
}) => {
  return (
    <Form.Item
      className={`input-primary ${className}`}
      name={name}
      rules={rules}
      label={label ? <span className="input-label">{label}</span> : undefined}
    >
      <Input.Password placeholder={placeholder} prefix={prefix} autoComplete={autocomplete} />
    </Form.Item>
  );
};

export default PasswordField;
